import React, { useEffect, useState, useRef } from 'react';
import {
    Grid, TextField, Box, Button, Typography, Autocomplete,
    TableCell, TableContainer, TableRow, TableBody, TableHead, Table, Paper, FormControl,
    InputLabel, Select, MenuItem, Breadcrumbs, Link,
} from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getRoomMasterdropdata } from '../../../src/Api/PropertyMst/Api';
import axiosInstance from '../../lib/axios';
import dayjs from 'dayjs';
import { Dialog, DialogTitle, IconButton } from '@mui/material';
import MuiDialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import { useReactToPrint } from 'react-to-print';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';
import PDFDownloadButton from './PDFDownloadButton';
import { useSelector, useDispatch } from 'react-redux';
import {
    selectProperties,
    selectGlobalProperty,
    selectLocalProperty,
    setLocalProperty,
    fetchProperties
} from '../../redux/propertySlice';
import HomeIcon from '@mui/icons-material/Home';

const Calculation = () => {
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [checkInDate, setCheckInDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [formData, setFormData] = useState({
        PlanName: '',
        ShortName: '',
        PlanTenur: '',
        FreeMonth: '',
        LastAdjMonths: '',
        MinAdjMonths: '',
        BalChargMonth: '',
        BillMonthCycl: '',
        IncRentPerc: '',
        DepositAmt: '',
        TotalInstall: '',
        Status: ''
    });
    const [openDialog, setOpenDialog] = useState(false);
    const [paymentSchedule, setPaymentSchedule] = useState([]);
    const [messAddone, setMessAddone] = useState([]);
    const [messAddtwo, setMessAddtwo] = useState([]);
    const [selectedAddone, setSelectedAddone] = useState(null);
    const [selectedAddtwo, setSelectedAddtwo] = useState(null);
    const [transportPlans, setTransportPlans] = useState([]);
    const [selectedPropertyDisplay, setSelectedPropertyDisplay] = useState(null);
    const [planSummary, setPlanSummary] = useState({
        totalRent: 0,
        discount: 0,
        netAmount: 0,
        adviceAmount: 0,
        incrementAmount: 0,
        addon1Amount: 0,
        addon2Amount: 0
    });
    const [rentOptions, setRentOptions] = useState([]);
    const [selectedRent, setSelectedRent] = useState(null);
    const [property, setProperty] = useState([]);
    const [planOption, setPlanOption] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [installmentDetails, setInstallmentDetails] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const properties = useSelector(selectProperties);
    const globalProperty = useSelector(selectGlobalProperty);
    const localProperty = useSelector(state => selectLocalProperty(state, 'planMaster'));
    const selectedProperty = localProperty || globalProperty;

    // FIX 1: Find the property object from properties array
    const selectedPropertyObject = properties.find(prop => prop.Id === (selectedProperty?.Id || selectedProperty)) || null;

    const fetchPlanOptions = async (propId) => {
        try {
            const response = await axiosInstance.post(`MstRoomPlan/getMstRoomPlandrp`, {
                Flag: "",
                PropId: propId,
            });
            if (
                response.data.Status === 0 &&
                response.data.responseStatusCode === 1 &&
                Array.isArray(response.data.Data)
            ) {
                setPlanOption(response.data.Data);
            } else {
                toast.error("Failed to fetch Room Plans");
                setPlanOption([]);
            }
        } catch (error) {
            toast.error("Error fetching Room Plans. Please try again.");
            setPlanOption([]);
        }
    };

    const fetchRentSelection = async (propId) => {
        try {
            const response = await axiosInstance.post(`RoomBedMst/GetdrpBedRent`, {
                Flag: "",
                PropId: propId,
                RoomId: 1,
                RoomBedId: 1,
                MobileNo: "",
                ResidentId: 1,
            });
            if (response.data.Status === 0 && response.data.responseStatusCode === 1 && Array.isArray(response.data.Data)) {
                const formattedData = response.data.Data.map((item, index) => ({
                    id: index,
                    Rent: item.BedRent || 0,
                    RoomBedId: item.RoomBedId || 1,
                }));
                setRentOptions(formattedData);
            } else {
                toast.error("Failed to fetch Rent Options");
                setRentOptions([]);
            }
        } catch (error) {
            toast.error("Error fetching Rent Options. Please try again.");
            setRentOptions([]);
        }
    };

    const fetchPropertyData = async () => {
        try {
            const userId = sessionStorage.getItem('UserId');
            const response = await getRoomMasterdropdata({
                Flag: '',
                UserId: userId,
            });
            if (response.data.Status === 0) {
                setProperty(response.data.Data);
            } else {
                toast.error(response.data.Message || 'Error fetching property data');
            }
        } catch (error) {
            toast.error('Failed to fetch property data');
        }
    };

    const fetchMessPlanAdd1 = async () => {
        const userId = sessionStorage.getItem('UserId');
        const Flag = "";
        try {
            const response = await axiosInstance.post(
                `MstMessPlan/getMstMessPlandrp`,
                { Flag, userId },
            );
            if (response.data.Status === 0) {
                setMessAddone(response.data.Data);
                setMessAddtwo(response.data.Data);
            } else {
                toast.error('Error fetching mess plan data');
            }
        } catch (error) {
            toast.error('Error fetching mess plan data');
        }
    };

    const fetchTransPlanAdd1 = async () => {
        const userId = sessionStorage.getItem('UserId');
        const Flag = "";
        try {
            const response = await axiosInstance.post(
                `MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId: userId }
            );
            if (response.data.Status === 0) {
                setTransportPlans(response.data.Data);
            } else {
                toast.error('Error fetching transport plan data');
            }
        } catch (error) {
            toast.error('Error fetching transport plan data');
        }
    };

    useEffect(() => {
        fetchPropertyData();
        fetchTransPlanAdd1();
        fetchMessPlanAdd1();
    }, []);

    // useEffect(() => {
    //     if (properties.length === 0) {
    //         dispatch(fetchProperties());
    //     }
    // }, [dispatch, properties.length]);

    useEffect(() => {
        if (selectedPropertyObject?.Id) {
            fetchRentSelection(selectedPropertyObject.Id);
            fetchPlanOptions(selectedPropertyObject.Id);
            setSelectedPropertyDisplay(selectedPropertyObject);
        }
    }, [selectedPropertyObject, properties]);

    const handlePropertyChange = (event) => {
        const selectedId = event.target.value;
        dispatch(setLocalProperty({
            componentId: 'planMaster',
            propertyId: selectedId
        }));

        const foundProperty = properties.find(prop => prop.Id === selectedId);
        setSelectedPropertyDisplay(foundProperty);
    };

    const handleRentChange = (event, newValue) => {
        setSelectedRent(newValue);
        setError((prev) => ({ ...prev, selectedRent: !newValue }));
    };

    const handleAddoneChange = (event, value) => {
        setSelectedAddone(value);
    };

    const handleAddtwoChange = (event, value) => {
        setSelectedAddtwo(value);
    };

    const [error, setError] = useState({
        selectedRent: false,
        PlanName: false,
        ShortName: false,
        Addone1: false,
        Addone2: false,
        selectedProperty: false
    });

    const handlePlanChange = (event, newValue) => {
        setSelectedPlan(newValue);
        if (newValue) {
            const tenureMonths = parseInt(newValue.PlanTenur || 0);
            const calculatedToDate = dayjs(checkInDate).add(tenureMonths, 'month');
            setFormData(prev => ({
                ...prev,
                PlanName: newValue.PlanId || newValue.RoomPlanID || '',
                PlanTenur: newValue.PlanTenur || '',
                FreeMonth: newValue.FreeMonth || '',
                LastAdjMonths: newValue.LastAdjMonths || '',
                MinAdjMonths: newValue.MinAdjMonths || '',
                BalChargMonth: newValue.BalChargMonth || '',
                BillMonthCycl: newValue.BillMonthCycl || '',
                IncRentPerc: newValue.IncRentPerc || '',
                DepositAmt: newValue.DepositAmt || '',
                TotalInstall: newValue.TotalInstall || '',
                Status: newValue.Status || ''
            }));
            setFromDate(dayjs(checkInDate).format('MM-DD-YYYY'));
            setToDate(calculatedToDate.format('MM-DD-YYYY'));
        } else {
            setFormData(prev => ({
                ...prev,
                PlanName: '',
                PlanTenur: '',
                FreeMonth: '',
                LastAdjMonths: '',
                MinAdjMonths: '',
                BalChargMonth: '',
                BillMonthCycl: '',
                IncRentPerc: '',
                DepositAmt: '',
                TotalInstall: '',
                Status: ''
            }));
            setFromDate('');
            setToDate('');
        }
    };

    const handleCalculate = async () => {
        const newErrors = {
            selectedRent: !selectedRent,
            PlanName: !formData.PlanName,
            selectedProperty: !selectedPropertyObject,
        };
        setError(newErrors);
        if (newErrors.PlanName || newErrors.selectedRent || newErrors.selectedProperty) {
            toast.error("Please fill all required fields");
            return;
        }

        try {
            const payload = {
                Flag: "",
                PropId: selectedPropertyObject?.Id || 1,
                RoomBedId: selectedRent?.Rent || "",
                RoomPlanId: selectedPlan?.PlanId || selectedPlan?.RoomPlanID || 1,
                TransPlanID: selectedAddone?.Id || 1,
                MessPlanID: selectedAddtwo?.Id || 1,
                PropName: selectedPropertyObject?.Name || "",
                RoomBedName: selectedRent?.RoomBedName || "",
                PlanName: selectedPlan?.PlanName || "",
                TransPlanName: selectedAddone?.TransPlanName || "",
                MessPlanName: selectedAddtwo?.MessPlanName || "",
                CheckinDt: checkInDate || "",
                BookId: 1
            };

            const response = await axiosInstance.post(`TrnBooking/AllRentGeneratePlanBooking`, payload);

            if (response.data.Status === 0 && response.data.responseStatusCode === 1 && Array.isArray(response.data.Data.TrnBookingList)) {
                const bookingList = response.data.Data.TrnBookingList;

                const payments = bookingList.map(item => ({
                    billDate: dayjs(item.BillDt).format('DD-MM-YYYY'),
                    monthYear: `${item.MonthNm} ${item.YearNm}`,
                    standardRent: String(item.StdRent).replace(/'/g, ''),
                    extraRentFromIncrement: String(item.ExtraRent).replace(/'/g, ''),
                    addOneAmount: String(item.TrspChrg).replace(/'/g, ''),
                    addTwoAmount: String(item.MessChrg).replace(/'/g, ''),
                    effectiveRent: String(item.EffRent).replace(/'/g, ''),
                    dueDate: dayjs(item.PyadDt).format('DD-MM-YYYY'),
                    adviceAmount: String(item.DueAmt).replace(/'/g, ''),
                    balance: String(item.BalPyadAmt).replace(/'/g, ''),
                    remarks: item.FmDisc > 0 ? `Discount ₹${String(item.FmDisc).replace(/'/g, '')}` : "",
                    pyadNo: item.pyadNo || '',
                    PyadDt: dayjs(item.PyadDt).format('DD-MM-YYYY'),
                    EffRent: item.EffRent || 0
                }));

                const totalRent = bookingList.reduce((sum, item) => sum + item.StdRent + item.ExtraRent, 0);
                const totalDiscount = bookingList.reduce((sum, item) => sum + item.FmDisc, 0);
                const netAmount = bookingList.reduce((sum, item) => sum + item.EffRent, 0);
                const adviceAmount = bookingList.reduce((sum, item) => sum + item.DueAmt, 0);
                const incrementAmount = bookingList.reduce((sum, item) => sum + item.ExtraRent, 0);
                const addon1Total = bookingList.reduce((sum, item) => sum + (item.TrspChrg || 0), 0);
                const addon2Total = bookingList.reduce((sum, item) => sum + (item.MessChrg || 0), 0);

                setPlanSummary({
                    totalRent: totalRent.toFixed(2),
                    discount: totalDiscount.toFixed(2),
                    netAmount: netAmount.toFixed(2),
                    adviceAmount: adviceAmount.toFixed(2),
                    incrementAmount: incrementAmount.toFixed(2),
                    addon1Amount: addon1Total.toFixed(2),
                    addon2Amount: addon2Total.toFixed(2)
                });

                setPaymentSchedule(payments);

                // Group payments by pyadNo to create installment details
                const installments = [];
                const groupedByPyadNo = {};

                bookingList.forEach(item => {
                    const pyadNo = item.pyadNo || '0';
                    if (!groupedByPyadNo[pyadNo]) {
                        groupedByPyadNo[pyadNo] = {
                            pyadNo: pyadNo,
                            dueDate: dayjs(item.PyadDt).format('DD-MM-YYYY'),
                            months: [],
                            totalRent: 0
                        };
                    }

                    // Add month/year if available
                    if (item.MonthNm && item.YearNm) {
                        groupedByPyadNo[pyadNo].months.push(`${item.MonthNm} ${item.YearNm}`);
                    }

                    groupedByPyadNo[pyadNo].totalRent += item.EffRent || 0;
                });

                // Convert to array and sort by pyadNo
                Object.values(groupedByPyadNo)
                    .sort((a, b) => parseInt(a.pyadNo) - parseInt(b.pyadNo))
                    .forEach((group, index) => {
                        installments.push({
                            installmentNumber: group.pyadNo,
                            monthsInInstallment: group.months.length,
                            installmentRent: group.totalRent.toFixed(2),
                            dueDate: group.dueDate
                        });
                    });

                setInstallmentDetails(installments);
                setOpenDialog(true);
            } else {
                toast.error(response.data.Message || "Failed to fetch booking data");
            }
        } catch (error) {
            toast.error("Error fetch data. Please try again.");
            console.error("API Error:", error);
        }
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    const handleBackClick = () => {
        navigate('/enquiry/pre-registration');
    };

    return (
        <>
            <Box className="form-container" sx={{ height: 'auto' }}>
                <ToastContainer />
                <Grid container spacing={3}
                    className='form_grid'
                    sx={{
                        padding: '20px',
                        background: 'linear-gradient(145deg, #ffffff, #f5f7fa)',
                        borderRadius: '16px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
                    }}
                >
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '10px',
                        }}
                    >
                        <IconButton
                            onClick={handleBackClick}
                            sx={{
                                left: '-50px',
                                color: '#6a11cb',
                                backgroundColor: 'rgba(106, 17, 203, 0.1)'
                            }}
                        >
                            <KeyboardBackspaceIcon />
                        </IconButton>
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: { xs: '24px', sm: '28px', md: '32px' },
                                fontWeight: 700,
                                background: 'linear-gradient(90deg, #6a11cb, #2575fc)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                textAlign: 'center',
                                position: 'relative',
                                '&:after': {
                                    content: '""',
                                    position: 'absolute',
                                    bottom: '-10px',
                                    left: '50%',
                                    width: '80px',
                                    height: '4px',
                                    transform: 'translateX(-50%)',
                                    background: 'linear-gradient(90deg, #6a11cb, #2575fc)',
                                    borderRadius: '2px'
                                }
                            }}
                        >
                            Rent Calculation
                        </Typography>
                    </Grid>

                    <Grid container item spacing={3} sx={{ mt: 2 }}>
                        <Grid item xs={12} md={4} className='form_field'>
                            <FormControl fullWidth>
                                <InputLabel id="property-select-label">Property Selection *</InputLabel>
                                <Select
                                    labelId="property-select-label"
                                    id="property-select"
                                    // FIX 2: Use selectedPropertyObject?.Id for value
                                    value={selectedPropertyObject?.Id || ''}
                                    onChange={handlePropertyChange}
                                    label="Property Selection *"
                                    error={error.selectedProperty}
                                    sx={{
                                        borderRadius: '10px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.2)',
                                        },
                                        '&.Mui-focused': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.3)',
                                        }
                                    }}
                                >
                                    {properties.map((property) => (
                                        <MenuItem key={property.Id} value={property.Id}>
                                            {property.Name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {error.selectedProperty && (
                                    <Typography variant="caption" color="error">
                                        Please select a property.
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                options={rentOptions}
                                id="rent-selection-autocomplete"
                                value={selectedRent}
                                onChange={handleRentChange}
                                getOptionLabel={(option) => option ? `Rent: ₹${option.Rent}` : ""}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            boxShadow: "0 4px 12px rgba(101, 119, 247, 0.2)",
                                        },
                                        "&.Mui-focused": {
                                            boxShadow: "0 4px 12px rgba(101, 119, 247, 0.3)",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <span>
                                                Rent Selection <span style={{ color: "#ff5252" }}>*</span>
                                            </span>
                                        }
                                        error={error.selectedRent}
                                        helperText={error.selectedRent ? "Please select a rent option." : ""}
                                        disabled={!selectedPropertyObject}
                                        className="custom-textfield"
                                        InputLabelProps={{
                                            style: { fontWeight: 500 },
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='form_field'>
                            <Autocomplete
                                options={planOption}
                                id="PlanName-autocomplete"
                                value={selectedPlan}
                                onChange={handlePlanChange}
                                getOptionLabel={(option) => option?.PlanName || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.PlanId === value?.PlanId || option.RoomPlanID === value?.RoomPlanID
                                }
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.2)',
                                        },
                                        '&.Mui-focused': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.3)',
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={<span>Select Plan <span style={{ color: '#ff5252' }}>*</span></span>}
                                        error={error.PlanName}
                                        helperText={
                                            error.PlanName ? 'Please select a plan.' : selectedPropertyObject ? '' : 'Select a property first'
                                        }
                                        className="custom-textfield"
                                        disabled={!selectedPropertyObject}
                                        InputLabelProps={{
                                            style: { fontWeight: 500 }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container item spacing={3} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={4} className='form_field'>
                            <TextField
                                fullWidth
                                type="date"
                                label="Check-in Date"
                                value={checkInDate}
                                onChange={(e) => {
                                    setCheckInDate(e.target.value);
                                    if (selectedPlan) {
                                        const tenureMonths = parseInt(selectedPlan.PlanTenur || 0);
                                        const calculatedToDate = dayjs(e.target.value).add(tenureMonths, 'month');
                                        setFromDate(e.target.value);
                                        setToDate(calculatedToDate.format('YYYY-MM-DD'));
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{
                                    borderRadius: "10px",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 4px 12px rgba(101, 119, 247, 0.2)",
                                    },
                                    "&.Mui-focused": {
                                        boxShadow: "0 4px 12px rgba(101, 119, 247, 0.3)",
                                    },
                                    "& .MuiInputBase-root": {
                                        height: "50px",
                                        borderRadius: "10px",
                                    },
                                    "& .MuiInputBase-input": {
                                        height: "50px",
                                        padding: "0 14px",
                                        boxSizing: "border-box"
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} className='form_field'>
                            <Autocomplete
                                options={transportPlans}
                                id="addone-autocomplete"
                                value={selectedAddone}
                                onChange={handleAddoneChange}
                                getOptionLabel={(option) => `${option.TransPlanName || ''} - ₹${option.Amount || 0}`}
                                isOptionEqualToValue={(option, value) => option.TransPlanID === value?.TransPlanID}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.2)',
                                        },
                                        '&.Mui-focused': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.3)',
                                        }
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} style={{ padding: '8px 16px' }}>
                                        <span style={{ fontWeight: 500 }}>{option.TransPlanName}</span>
                                        <span style={{
                                            marginLeft: 'auto',
                                            fontWeight: 600,
                                            color: '#2575fc'
                                        }}>₹{option.Amount}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={<span>AddOn 1</span>}
                                        className="custom-textfield"
                                        InputLabelProps={{
                                            style: { fontWeight: 500 }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} className='form_field'>
                            <Autocomplete
                                options={messAddtwo}
                                id="addtwo-autocomplete"
                                value={selectedAddtwo}
                                onChange={handleAddtwoChange}
                                getOptionLabel={(option) => `${option.MessPlanName || ''} - ₹${option.Amount || 0}`}
                                isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '10px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.2)',
                                        },
                                        '&.Mui-focused': {
                                            boxShadow: '0 4px 12px rgba(101, 119, 247, 0.3)',
                                        }
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} style={{ padding: '8px 16px' }}>
                                        <span style={{ fontWeight: 500 }}>{option.MessPlanName}</span>
                                        <span style={{
                                            marginLeft: 'auto',
                                            fontWeight: 600,
                                            color: '#2575fc'
                                        }}>₹{option.Amount}</span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={<span>Addon 2</span>}
                                        className="custom-textfield"
                                        InputLabelProps={{
                                            style: { fontWeight: 500 }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Button
                                variant="contained"
                                onClick={handleCalculate}
                                sx={{
                                    background: 'linear-gradient(45deg, #6a11cb, #2575fc)',
                                    color: '#fff',
                                    padding: '10px 30px',
                                    borderRadius: '30px',
                                    fontWeight: 600,
                                    letterSpacing: '0.5px',
                                    boxShadow: '0 10px 20px rgba(37, 117, 252, 0.2)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #2575fc, #6a11cb)',
                                        boxShadow: '0 15px 25px rgba(37, 117, 252, 0.3)',
                                        transform: 'translateY(-2px)'
                                    },
                                }}
                            >
                                Calculate Rent
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{
                        sx: {
                            width: '90%',
                            maxWidth: '1300px',
                            height: 'auto',
                            maxHeight: '90vh'
                        }
                    }}
                >

                    <DialogTitle>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">Plan Results</Typography>
                            <Box>
                                {/* <Button
                                    variant="outlined"
                                    startIcon={<PrintIcon />}
                                    onClick={() => reactToPrintFn()}
                                    sx={{ mr: 1 }}
                                >
                                    Print
                                </Button> */}
                                <PDFDownloadButton
                                    selectedProperty={selectedPropertyObject}
                                    selectedPlan={selectedPlan}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    selectedAddone={selectedAddone}
                                    selectedAddtwo={selectedAddtwo}
                                    formData={formData}
                                    planSummary={planSummary}
                                    paymentSchedule={paymentSchedule}
                                    installmentDetails={installmentDetails}
                                    checkInDate={checkInDate}
                                />
                                <IconButton onClick={handleCloseDialog} aria-label="close">
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </DialogTitle>
                    <MuiDialogContent dividers sx={{ p: 2, pt: 1 }}>
                        <div ref={contentRef}>
                            <Box sx={{ mb: 2, px: 4 }}>
                                <Typography variant="h5" sx={{ mb: 1, textAlign: 'center', fontWeight: 'bold' }}>
                                    Plan Details
                                </Typography>
                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Property:</Typography>
                                            <Typography variant="body1">{selectedPropertyObject?.Name || selectedPropertyDisplay?.Name || '-'}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Plan:</Typography>
                                            <Typography variant="body1">{selectedPlan?.PlanName || '-'}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Check-in Date:</Typography>
                                            <Typography variant="body1">{checkInDate ? dayjs(checkInDate).format('DD-MM-YYYY') : '-'}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>From Date:</Typography>
                                            <Typography variant="body1">{fromDate ? dayjs(fromDate).format('DD-MM-YYYY') : '-'}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>To Date:</Typography>
                                            <Typography variant="body1">{toDate ? dayjs(toDate).format('DD-MM-YYYY') : '-'}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Tenure:</Typography>
                                            <Typography variant="body1">{formData.PlanTenur || '-'} months</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Addon1:</Typography>
                                            <Typography variant="body1">
                                                {selectedAddone ? `${selectedAddone.TransPlanName} - ₹${selectedAddone.Amount}` : '-'}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Addon2:</Typography>
                                            <Typography variant="body1">
                                                {selectedAddtwo ? `${selectedAddtwo.MessPlanName} - ₹${selectedAddtwo.Amount}` : '-'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" gap={1} alignItems="center">
                                            <Typography variant="subtitle2" fontWeight='bold'>Address:</Typography>
                                            <Typography variant="body1">
                                                <Typography variant="body1">{selectedPropertyObject?.Addr || selectedPropertyDisplay?.Addr || '-'}</Typography>
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Paper elevation={2} sx={{ px: 1, py: 1, pt: 0, mb: 2 }}>
                                <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', borderBottom: '1px solid #e0e0e0' }}>
                                    Plan Details Info
                                </Typography>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                <TableCell>Plan</TableCell>
                                                <TableCell>Tenure</TableCell>
                                                <TableCell>Free Month</TableCell>
                                                <TableCell>Min Adv Month</TableCell>
                                                <TableCell>Balance Charge Month</TableCell>
                                                <TableCell>Bill Cycle</TableCell>
                                                <TableCell>Increment %</TableCell>
                                                <TableCell>Deposit</TableCell>
                                                <TableCell>Total Installments</TableCell>
                                                <TableCell>Total Rent</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>{selectedPlan?.PlanName || '-'}</TableCell>
                                                <TableCell>{formData.PlanTenur || '-'}</TableCell>
                                                <TableCell>{formData.FreeMonth || '0'}</TableCell>
                                                <TableCell>{formData.MinAdjMonths || '-'}</TableCell>
                                                <TableCell>{formData.BalChargMonth || '-'}</TableCell>
                                                <TableCell>{formData.BillMonthCycl || '-'}</TableCell>
                                                <TableCell>{formData.IncRentPerc || '-'}%</TableCell>
                                                <TableCell>₹{formData.DepositAmt || '0'}</TableCell>
                                                <TableCell>{formData.TotalInstall || '-'}</TableCell>
                                                <TableCell>₹{planSummary.totalRent.toLocaleString()}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                            <Paper elevation={2} sx={{ px: 1, py: 1, pt: 0, mb: 2 }}>
                                <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', borderBottom: '1px solid #e0e0e0' }}>
                                    Payment Schedule
                                </Typography>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                <TableCell>Bill Date</TableCell>
                                                <TableCell>Month/Year</TableCell>
                                                <TableCell>Standard Rent</TableCell>
                                                <TableCell>Increment</TableCell>
                                                <TableCell>Addon1</TableCell>
                                                <TableCell>Addon2</TableCell>
                                                <TableCell>Effective Rent</TableCell>
                                                <TableCell>Payment No</TableCell>
                                                <TableCell>Payment Date</TableCell>
                                                <TableCell>Remarks</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {paymentSchedule.map((payment, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{payment.billDate}</TableCell>
                                                    <TableCell>{payment.monthYear}</TableCell>
                                                    <TableCell>₹{payment.standardRent}</TableCell>
                                                    <TableCell>₹{payment.extraRentFromIncrement}</TableCell>
                                                    <TableCell>₹{payment.addOneAmount}</TableCell>
                                                    <TableCell>₹{payment.addTwoAmount}</TableCell>
                                                    <TableCell>₹{payment.effectiveRent}</TableCell>
                                                    <TableCell>{payment.pyadNo}</TableCell>
                                                    <TableCell>{payment.PyadDt}</TableCell>
                                                    <TableCell>{payment.remarks}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                            <Paper elevation={2} sx={{ px: 1, py: 1, pt: 0, mb: 2 }}>
                                <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', borderBottom: '1px solid #e0e0e0' }}>
                                    Summary
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Total Rent:</Typography>
                                        <Typography variant="body1">₹{planSummary.totalRent?.toLocaleString()}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Increment Amount:</Typography>
                                        <Typography variant="body1">₹{planSummary.incrementAmount?.toLocaleString()}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Discount:</Typography>
                                        <Typography variant="body1">₹{planSummary.discount?.toLocaleString()}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Net Amount:</Typography>
                                        <Typography variant="body1">₹{planSummary.netAmount?.toLocaleString()}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Addon 1 Total:</Typography>
                                        <Typography variant="body1">₹{planSummary.addon1Amount?.toLocaleString()}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Typography variant="subtitle1">Addon 2 Total:</Typography>
                                        <Typography variant="body1">₹{planSummary.addon2Amount?.toLocaleString()}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper elevation={2} sx={{ px: 1, py: 1, pt: 0, mb: 2 }}>
                                <Typography variant="h6" sx={{ mb: 1, color: 'primary.main', borderBottom: '1px solid #e0e0e0' }}>
                                    Installment Details
                                </Typography>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                <TableCell>Installment Number</TableCell>
                                                <TableCell>Months in Installment</TableCell>
                                                <TableCell>Installment Rent</TableCell>
                                                <TableCell>Due Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {installmentDetails.map((installment, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{installment.installmentNumber}</TableCell>
                                                    <TableCell>{installment.monthsInInstallment}</TableCell>
                                                    <TableCell>₹{installment.installmentRent}</TableCell>
                                                    <TableCell>{installment.dueDate}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </div>
                    </MuiDialogContent>
                </Dialog>
            </Box>
        </>
    );
};

export default Calculation;